import React, { useMemo } from 'react';
import { SelectAncillariesContext } from 'context';
import { gql, useMutation } from '@edreamsodigeo/frontend-api-client';
import { useLogger } from '@edreamsodigeo/frontend-core';

const SET_CABIN_BAGS_QUERY = gql`
  mutation SelectAncillariesForCabinBags($request: SelectAncillariesRequest!) {
    selectAncillaries(request: $request) {
      success
      code
      message
      products {
        type
        id
      }
    }
  }
`;

export const SelectAncillariesProvider = ({ children }) => {
  const { error } = useLogger();
  const response = useMutation(SET_CABIN_BAGS_QUERY, {
    onError: () => {
      error('Failed to select cabin bags');
    },
    emitOnError: true,
  });

  const value = useMemo(() => response, [response]);

  return (
    <SelectAncillariesContext.Provider value={value}>
      {children}
    </SelectAncillariesContext.Provider>
  );
};
